"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = withMetadataArgument;

var _metadataMinJson = _interopRequireDefault(require("../../metadata.min.json.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Importing from a ".js" file is a workaround for Node.js "ES Modules"
// importing system which is even uncapable of importing "*.json" files.
function withMetadataArgument(func, _arguments) {
  var args = Array.prototype.slice.call(_arguments);
  args.push(_metadataMinJson.default);
  return func.apply(this, args);
}